<template>
  <div class="statistics-panel">
      <div class="statistics-options">
        <div class="statistics-group-selection">
          <multi-select-component
            label="Baseline Group"
            mode="single"
            v-model="baselineGroup"
            :options="groupsAndTrials"
          />
        </div>
        <div class="statistics-group-selection">
          <multi-select-component
            label="Study Groups"
            mode="multiple"
            v-model="studyGroups"
            :options="groupsAndTrials"
          />
        </div>
        <div class="btn btn--primary" @click="generateStatistics">
          {{ $t("submit") }}
        </div>
      </div>
      <div class="statistics-body">
        <div v-if="'anova' in this.statisticalTestResults">
          <h3 class="statistics-title">ANOVA</h3>
          <div class="results-values">
            <div class="results-scrollable">
              <div class="value-block" v-for="(value, field) in this.statisticalTestResults.anova" :key="field">
                <div class="field-name">{{ field }}</div>
                <div class="group-all-value" v-if="value !== ''">{{ value }}</div>
                <div class="group-all-value" v-else>NaN</div>
              </div>            
            </div>          
          </div>
        </div>
        <div v-for="pair in this.statisticalTestResults.pairwise_tests" :key="pair">
          <h3 class="statistics-title">{{ pair.group_a.name }} - {{ pair.group_b.name }}</h3>
          <div class="results-values">
              <div class="value-block" v-for="(value, field) in pair.results[0]" :key="field">
                <div class="field-name">{{ field }}</div>
              </div>            
          </div>
          <div class="value-block" v-for="(value, field) in test" :key="field">
            <div class="field-name">Groups</div>
            <div class="group-all-value">NaN</div>
          </div>
          <div class="value-block" v-for="(value, field) in test" :key="field">
            <div class="field-name">Test</div>
            <div class="group-all-value">NaN</div>
          </div>
          <div class="results-values" v-for="test in pair.results" :key="test">
              <div class="value-block" v-for="(value, field) in test" :key="field">
                <div class="group-all-value" v-if="value !== ''">{{ value }}</div>
                <div class="group-all-value" v-else>NaN</div>
              </div>            
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import MultiSelectComponent from '@/components/MultiSelectComponent'
import TextInput from '@/components/inputs/inputsTypes/TextInput'
import Api from '@/api'

export default {
  name: 'StatisticalValuesPanel',
  components: {MultiSelectComponent, TextInput},
  props: ['groupsAndTrials', 'statisticalTestResults'],
  data () {
    return {
      baselineGroup: null,
      studyGroups: [],
    }
  },
  computed: {},
  methods: {
    generateStatistics() {
      Api.getStatistics(
        this.baselineGroup, this.studyGroups
      ).then(
        (results) => {
          this.statisticalTestResults = results
          this.$emit('statisticalAnalysisLoaded', results)
        }
      )
    }
  }
}
</script>

<style lang="stylus" scoped>
.statistics-panel
  padding: 10px
  width 100%
  height: 100%
  overflow auto
  padding-bottom 10px

  .statistics-options
    display: flex
    flex-direction: row
    width: 100%

    .statistics-group-selection
      display: flex
      flex-direction: column
      width: 300px
      padding-right: 20px

    .btn
      max-height: 40px
      margin-top: auto
      float: right

  .statistics-body
    height: 75%

    .results-values
      $margin = 1px
      display: flex
      margin-left: -($margin)
      margin-right: -($margin)
      .results-scrollable
        width 100%
        overflow auto
        display flex
        flex-wrap nowrap
        padding-bottom 10px
      .value-block
        //$percentage = percentage((1 / 6))
        // $margin = 10px
        $width = 100px //"calc(%s - %s * 2)" % ($percentage $margin)
        flex: 0 0 $width
        // flex: 0 0 percentage((1 / 6))
        margin: $margin

        .field-name
          color: $gull-gray
          m-font-size(10, 12)
          margin-bottom: 2px
          text-transform: uppercase
          min-height 16px
          height 16px

        .group-all-value,
        .selection-value
          background-color: rgba($gull-gray, 0.1)
          border-radius: 2px
          m-font-size(14, 16)
          padding: 4px 6px
          text-align: center

        .group-all-value
          color: $titan-white
</style>